<div class="site-text">
    <p class="text">
        La seguente lista vi aiuterà a trovare il più rapidamente possibile una risposta o la persona di contatto più appropriata per la vostra richiesta.
    </p>
    <p class="title">
        La mia organizzazione non è presente nell’elenco.
    </p>
    <p class="text">
        eDirectory.ch contiene un elenco delle aziende e organizzazioni domiciliate in Svizzera che scambiano fatture elettroniche con partner commerciali tramite un fornitore di servizi di e-invoicing aderente a eDirectory e che hanno concesso a quest’ultimo il diritto di pubblicazione in eDirectory. In caso di domande, rivolgetevi al vostro fornitore di servizi di e-invoicing.
    </p>
    <p class="text">
        Gli emittenti che inviano fatture elettroniche a destinatari eBill possono essere trovati utilizzando le relative funzioni eBill nelle applicazioni di e-banking delle banche svizzere. In caso di domande, contattate il vostro partner di rete eBill.
        <br>
        Maggiori informazioni su <a href="https://www.ebill.ch" target="_blank">www.ebill.ch</a>
    </p>
    <p div class="title">
        I dati relativi alla mia organizzazione non sono corretti.
    </p>
    <p class="text">
        Informate il vostro fornitore di servizi di e-invoicing affinché possa modificare i dati.
    </p>
    <p class="title">
        In quanto fornitore di servizi di e-invoicing, vorrei tenere un elenco dei miei clienti anche su eDirectory.ch.
    </p>
    <p class="text">
        Se in qualità di service provider offrite servizi di e-invoicing ad aziende e organizzazioni domiciliate in Svizzera e desiderate pubblicare i vostri clienti su eDirectory, comunicatelo a PostFinance <a href="mailto:billing-solutions@postfinance.ch?subject=eDirectory">(billing-solutions@postfinance.ch)</a>. Vi contatteremo al più presto.
    </p>
</div>
